import { render, staticRenderFns } from "./GenerateLink.vue?vue&type=template&id=fa36063e&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./GenerateLink.vue?vue&type=style&index=0&id=fa36063e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa36063e",
  null
  
)

export default component.exports